import {Form} from "@/utils/Form";
import {DataSource} from "./dataSource";
import deepEqual from "deep-equal";
import {useDomainQuotaDefaultsUpdateMutation} from "../mutations.generated";
import {DomainQuotaDefaultsInfo} from "@/api";
import {DomainQuotaDefaultsUpdateMutation, DomainQuotaDefaultsUpdateMutationVariables} from "../mutations.generated";

export default class DomainQuotaDefaultsForm extends Form<
    DomainQuotaDefaultsUpdateMutation,
    DomainQuotaDefaultsUpdateMutationVariables,
    DomainQuotaDefaultsInfo
> {
    private readonly domainId: number;
    readonly dataSource: DataSource;

    constructor(domainId: number, dataSource: DataSource) {
        super("domainQuotaDefaultsUpdate");
        this.hooks(useDomainQuotaDefaultsUpdateMutation, dataSource.data);
        this.domainId = domainId;
        this.dataSource = dataSource;
    }

    override async submit(): Promise<boolean> {
        const res = await super.submit();
        if (res) {
            this.clearCache();
            this.newInitialData(await this.dataSource.refetch());
        }
        return res;
    }

    updateDevice(name: string, value: number): void {
        const devices = structuredClone(this.values.defaultDevices);
        const target = devices.find((p) => p.name === name);
        target.value = value;
        this.updateValues({defaultDevices: devices});
    }

    protected override get filteredVariables(): DomainQuotaDefaultsUpdateMutationVariables {
        const values = structuredClone(this.values);

        if (values.defaultUserPackage === this.initialData.defaultUserPackage) delete values.defaultUserPackage;
        values.defaultDevices = values.defaultDevices.filter(
            (p, i) => p.value !== this.initialData.defaultDevices[i].value,
        );
        if (deepEqual(values.defaultCapabilities, this.initialData.defaultCapabilities))
            delete values.defaultCapabilities;

        // FIXME: This is a hack to remove the limit field from the device object
        // but we should not even store it in the first place
        if (values.defaultDevices) {
            for (const device of values.defaultDevices) {
                delete (device as {limit?: number | null}).limit;
            }
        }

        const data = {
            domainId: this.domainId,
            userPackageName: values.defaultUserPackage,
            devices: values.defaultDevices,
            capabilities: values.defaultCapabilities,
        } as DomainQuotaDefaultsUpdateMutationVariables;

        return data;
    }

    override get hasChanged(): boolean {
        // TODO!: defaultCapabilities always shows not equal when set to none and submitted
        if (this.values) return !deepEqual(this.values, this.initialData);
        else return false;
    }
}
